import { Grid, Avatar, Typography, Button, useTheme, Collapse, Link, Chip, Box, Skeleton } from '@mui/material'
import { ChatBubbleOutlineOutlined, Edit, FmdGoodOutlined, WorkspacePremiumOutlined } from '@mui/icons-material';
import React, { useState } from 'react'
import moment from 'moment';
import { useGetTalentQuery } from '../../../../Redux/api/talentApi';
import { removeUnwantedCharacters, toPascalCase } from '../../../../Utils/String';
import { useAppSelector } from '../../../../Redux/store';
import { skipToken } from '@reduxjs/toolkit/query';
import { useParams, useSearchParams } from 'react-router-dom';
import { TalentProfileSkeleton } from './TalentProfileSkeleton';
import { ViewTalentProfile } from './View/ViewTalentProfile';
import { EditTalentProfile } from './Edit/EditTalentProfile';
import { KaziLayout } from '../../../../Shared Components/Kazi/Layouts/KaziLayout';

export const TalentProfile = () => {
    /* ******************** Hooks ******************** */    
    const { locator } = useParams();
    const userId = useAppSelector( state => state.Global.userId)
    const {data: talentData, isLoading: talentDataLoading, isFetching: talentDataFetching} = useGetTalentQuery((locator ?? userId) || skipToken); 
    /* ******************** Variables ******************** */
    const [mode, setMode] = useState<'view' | 'edit'>('view')
    /* ******************** Functions ******************** */
    /* ******************** Effects ******************** */
    /* ******************** JSX ******************** */
    return (        
        <KaziLayout>
            {talentDataLoading || talentDataFetching ?
            <TalentProfileSkeleton />
            : (
                mode === 'view' ? 
                <ViewTalentProfile talentData={talentData!} mode={mode} setMode={setMode}/> : 
                <EditTalentProfile talentData={talentData!} mode={mode} setMode={setMode}/>
            )
            }
        </KaziLayout>
    )
}